export default __webpack_public_path__ + "static/media/la_ferte-vidame10.2ca588a4.jpg";